import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProjectProposal.css';
import printWhiteSvg from 'images/print-white.svg';
import { getShowEmailModal } from 'components/admin/projects/details/project-email-modal/store/selectors';
import { sendProjectResourceEmails } from 'components/admin/projects/details/store/actions';
import ProjectEmailModal from 'components/admin/projects/details/project-email-modal/ProjectEmailModal';
import ProjectCancelledOrLostModal from './ProjectCancelledOrLostModal';
import moment from 'moment';
import Button from 'components/shared/button/Button';
import { Enterprise } from 'domain/enterprise';
import { ProjectStatusEnum } from 'domain/project-status-enum';
import { getCurrentUser } from 'selectors/authentication';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import {
  getShowCreateProposal,
  getShowCreateProposalSuccess,
  getShowPdfViewer,
  getProjectProposalItems,
  getProjectProposal,
  getProjectProposalPdf,
  getShowApproveProposalSuccess,
  getReadOnly,
  getShowLostOrCancelledModal,
  getIsCancelledModal,
} from 'components/admin/projects/details/project-proposal/store/selectors';
import {
  initProjectProposal,
  buildProjectProposalForm,
  toggleCreateProposal,
  toggleCreateProposalSuccess,
  togglePdfViewer,
  toggleApproveProposalSuccess,
  loadProjectProposalRequest,
  loadProjectProposalPdfRequest,
  newItem,
  loadCsiCodes,
  setReadOnly,
} from 'components/admin/projects/details/project-proposal/store/actions';
import ProjectProposalForm from 'components/admin/projects/details/project-proposal/ProjectProposalForm';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';
import MessageModal from 'components/shared/modal/MessageModal';

class ProjectProposal extends Component {
  constructor(props) {
    super(props);

    props.dispatch(initProjectProposal());
    this.showActions = Enterprise.showActions(props.currentUser);
  }

  componentDidMount() {
    if (this.props.currentProject) {
      this.props.dispatch(loadCsiCodes()).then((response) => {
        if (response.ok) {
          const csiCodes = response.csiCodes;
          this.props
            .dispatch(loadProjectProposalRequest(this.props.currentProject.id))
            .then((response) => {
              if (response.ok) {
                if (response.projectProposal === null) {
                  this.props.dispatch(toggleCreateProposal());
                  csiCodes.forEach((csiCode) => {
                    this.props.dispatch(
                      newItem(this.props.projectProposalItems, csiCode.id)
                    );
                  });
                } else {
                  this.handleToggleReadOnly();
                  this.props.dispatch(
                    buildProjectProposalForm(response.projectProposal)
                  );
                }
              }
            });
        }
      });
    }
  }

  handleCreateProposal = () => {
    this.props.dispatch(toggleCreateProposal());
  };

  handleEditProposal = () => {
    this.props.dispatch(toggleCreateProposalSuccess());
  };

  handlePdfViewerClose = () => {
    this.props.dispatch(togglePdfViewer());
  };

  handleGeneratePdf = () => {
    this.props
      .dispatch(loadProjectProposalPdfRequest(this.props.currentProject.id))
      .then(() => this.props.dispatch(togglePdfViewer()));
  };

  handleCloseApproveSuccessModal = () => {
    this.props.dispatch(toggleApproveProposalSuccess());
  };

  handleToggleReadOnly = () => {
    this.props.dispatch(setReadOnly(!this.props.readOnly));
  };

  showApprove = () => {
    const projStatus = ProjectStatusEnum.create(
      this.props.currentProject.status
    );
    return ProjectStatusEnum.PENDING.equals(projStatus);
  };

  showLost = () => {
    const projStatus = ProjectStatusEnum.create(
      this.props.currentProject.status
    );
    return ProjectStatusEnum.PENDING.equals(projStatus);
  };

  showCancel = () => {
    const projStatus = ProjectStatusEnum.create(
      this.props.currentProject.status
    );
    return (
      ProjectStatusEnum.PENDING.equals(projStatus) ||
      ProjectStatusEnum.PRECON.equals(projStatus)
    );
  };

  showMobilize = () => {
    const projStatus = ProjectStatusEnum.create(
      this.props.currentProject.status
    );
    return ProjectStatusEnum.PRECON.equals(projStatus);
  };

  showClose = () => {
    const projStatus = ProjectStatusEnum.create(
      this.props.currentProject.status
    );
    return ProjectStatusEnum.IN_PROGRESS.equals(projStatus);
  };

  handleSendEmail = (emailsData) => {
    this.props.dispatch(
      sendProjectResourceEmails(
        this.props.projectProposal.id,
        'ProjectProposal',
        emailsData
      )
    );
  };

  buildEmailModalTitle = () => {
    const { currentProject } = this.props;
    return `Proposal (Project #${currentProject.number}: ${currentProject.name})`;
  };

  buildEmailModalSubject = () => {
    const { currentProject } = this.props;
    return `${currentProject.number}, ${currentProject.name} - Proposal`;
  };

  buildEmailModalMessage = () => {
    const { currentProject } = this.props;
    let location = '';
    if (currentProject.building && currentProject.building.location) {
      const buildingLocation = currentProject.building.location;
      location = ` at ${buildingLocation.street_address_1}, ${buildingLocation.city} ${buildingLocation.state}`;
    }

    return `Please find the attached Proposal for Project ${currentProject.name}${location}. If you have any questions, please reach out via chat or email.`;
  };

  render() {
    return (
      <div className="project-proposal">
        {this.props.currentProject &&
          (this.props.showCreateProposal ? (
            <div className="proposal-create">
              <h3>Create a Proposal</h3>
              <div className="proposal-create-message">
                <div>
                  First things first, generate a proposal for your potential
                  client.
                </div>
                <div>
                  Once accepted, you can add the rest of the information to the
                  project.
                </div>
              </div>
              <Button
                className="btn button button-orange"
                label="Create Proposal"
                onClick={this.handleCreateProposal}
              />
            </div>
          ) : this.props.showCreateProposalSuccess &&
            this.props.projectProposal ? (
            <div className="proposal-create-success">
              <h2>{`${
                this.props.currentProject.general_contractor.name
              } Bid Proposal - ${moment(
                this.props.projectProposal.updated_at
              ).format('MM/DD/YYYY')}`}</h2>
              <div className="buttons-container">
                <Button
                  className="btn button button-gray"
                  icon={printWhiteSvg}
                  label="Generate PDF"
                  onClick={this.handleGeneratePdf}
                />
                <Button
                  className="btn button button-orange"
                  label="Back to Proposal"
                  onClick={this.handleEditProposal}
                />
              </div>
            </div>
          ) : (
            <ProjectProposalForm
              onGeneratePdf={this.handleGeneratePdf}
              onToggleReadOnly={this.handleToggleReadOnly}
              readOnly={this.props.readOnly}
              showApprove={this.showApprove()}
              showActions={this.showActions}
              showLost={this.showLost()}
              showCancel={this.showCancel()}
              showMobilize={this.showMobilize()}
              showClose={this.showClose()}
            />
          ))}

        <PdfViewer
          content={{
            source: this.props.projectProposalPdf,
            type: 'blob',
          }}
          show={this.props.showPdfViewer}
          onClose={this.handlePdfViewerClose}
        />

        {this.props.showEmailModal && (
          <ProjectEmailModal
            title={this.buildEmailModalTitle()}
            handleSendEmail={this.handleSendEmail}
            projectId={this.props.currentProject.id}
            initialSubject={this.buildEmailModalSubject()}
            initialMessage={this.buildEmailModalMessage()}
          />
        )}

        {this.props.showLostOrCancelledModal && (
          <ProjectCancelledOrLostModal
            statusSelected={this.props.isCancelledModal ? 'cancelled' : 'lost'}
            showLostOrCancelledModal={this.props.showLostOrCancelledModal}
            projectId={this.props.currentProject.id}
            terminationDate={this.props.currentProject.termination_date}
            terminationReason={this.props.currentProject.termination_reason}
            projectTerminationCategory={
              this.props.currentProject.termination_category
            }
          />
        )}

        <MessageModal
          show={this.props.showApproveProposalSuccess}
          message={
            <div>
              Thank you. Your Client has been invited to Spackle to join this
              Project.
            </div>
          }
          onHide={this.handleCloseApproveSuccessModal}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentProject: getCurrentProject(state),
    projectProposal: getProjectProposal(state),
    projectProposalPdf: getProjectProposalPdf(state),
    showCreateProposal: getShowCreateProposal(state),
    showPdfViewer: getShowPdfViewer(state),
    showCreateProposalSuccess: getShowCreateProposalSuccess(state),
    showApproveProposalSuccess: getShowApproveProposalSuccess(state),
    projectProposalItems: getProjectProposalItems(state),
    readOnly: getReadOnly(state),
    showEmailModal: getShowEmailModal(state),
    showLostOrCancelledModal: getShowLostOrCancelledModal(state),
    isCancelledModal: getIsCancelledModal(state),
  };
})(ProjectProposal);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-proposal/ProjectProposal.js